import Input from 'components/input/input';
import Textarea from 'components/textarea/textarea';
import TextEditor from 'components/text_editor/text_editor';
import DateTimePicker from 'components/date_time_picker/date_time_picker';
import Radio from 'components/radio/radio';
import PhoneNumber from 'components/phone_number/phone_number';
import Select from 'components/select/select';
import Address from 'components/address/address';

import { PATIENT_RIGHT_OPTIONS } from 'config/referral';
import { GENDER_OPTIONS } from 'config/customer';
import { CARTE_VITALE_REGEX } from 'helpers/customer';

import useWindowDimensions, {
  isMobileResolution,
} from 'helpers/useWindowDimensions';

const GeneralInfo = ({
  customer,
  customerDoctors,
  validation,
  doctorOptions,
  onChange,
  onAddressSelect,
  onPatientRightsChange,
  onGenderChange,
  onDateChange,
  onPhoneChange,
  onDoctorSelect,
}) => {
  const { width } = useWindowDimensions();
  const isMobile = isMobileResolution(width);

  if (!customer) return;

  let formattedCarteVitale = customer.carteVitale;

  if (customer.carteVitale) {
    formattedCarteVitale = customer.carteVitale.replace(
      CARTE_VITALE_REGEX,
      '$1 $2 $3 $4 $5 $6 $7',
    );
  }

  const DesktopView = (
    <section>
      <div className="pa5 pt4 br4 br--bottom-top bg-grouped-table flex flex-column">
        <div className="w-100 flex flex-column">
          <div className="w-100 flex flex-row items-start justify-between margin-between">
            <div className="w-50">
              <Input
                name="lastName"
                label="Last Name"
                value={customer.lastName}
                valid={true}
                isCopiable={true}
                onChange={onChange}
              />
            </div>
            <div className="w-50">
              <Input
                name="firstName"
                label="First Name"
                value={customer.firstName}
                valid={true}
                isCopiable={true}
                onChange={onChange}
              />
            </div>
          </div>
          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-50">
              <Input
                name="carteVitale"
                label="Carte Vitale number"
                value={formattedCarteVitale}
                valid={validation.carteVitale}
                validationText="Carte Vitale number must contain 15 digits"
                isCopiable={true}
                onChange={onChange}
              />
            </div>
            <div className="w-50">
              <DateTimePicker
                label="Date of Birth"
                name="dob"
                valid={true}
                showYearDropdown={true}
                showTimeInput={false}
                value={customer.dateOfBirth}
                onChange={(value) => onDateChange({ value })}
              />
            </div>
          </div>
          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-50">
              <PhoneNumber
                name="phone"
                label="Phone number"
                value={customer.phone}
                isCopiable={true}
                valid={validation.phone}
                onChange={onPhoneChange}
              />
            </div>
            <div className="w-50">
              <Input
                name="email"
                label="Email*"
                value={customer.email}
                valid={validation.email}
                validationText="Please enter a valid email"
                isCopiable={true}
                onChange={onChange}
              />
            </div>
          </div>
          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-50">
              <Address
                value={customer.address}
                name="address"
                label="Adresse line 1"
                type="text"
                valid={true}
                isCopiable={true}
                onChange={onChange}
                onSelect={(p) => {
                  onAddressSelect(p.formatted_address);
                }}
              />
            </div>
            <div className="w-50">
              <Input
                name="address2"
                label="Address line 2"
                value={customer.address2}
                valid={true}
                placeholder="Code, intercom, floor, apartment"
                isCopiable={true}
                onChange={onChange}
              />
            </div>
          </div>

          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-50">
              <Select
                className="doctor-select"
                valid={true}
                isMulti
                label="Non-sleep doctors"
                value={customerDoctors}
                options={doctorOptions}
                onChange={(selectedOption) => onDoctorSelect(selectedOption)}
              />
            </div>
            <div className="w-50"></div>
          </div>

          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-100">
              <Radio
                name="patientRights"
                label="Patient's rights"
                value={customer.patientRights}
                valid={true}
                options={PATIENT_RIGHT_OPTIONS}
                onChange={(event) => onPatientRightsChange(event)}
              />
            </div>
          </div>

          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-100">
              <Radio
                name="gender"
                label="Gender"
                value={customer.gender}
                valid={true}
                options={GENDER_OPTIONS}
                onChange={(event) => onGenderChange(event)}
              />
            </div>
          </div>

          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-33">
              <Input
                name="height"
                label="Height"
                value={customer.height}
                valid={validation.height}
                validationText="Invalid input"
                trailingLabel={'cm'}
                onChange={onChange}
              />
            </div>
            <div className="w-33">
              <Input
                name="weight"
                label="Weight"
                value={customer.weight}
                valid={validation.weight}
                validationText="Invalid input"
                trailingLabel={'kg'}
                onChange={onChange}
              />
            </div>
            <div className="w-33">
              <Input
                name="bmi"
                label="BMI"
                value={customer.bmi}
                valid={true}
                disabled
                trailingLabel={'kg/m2'}
                onChange={onChange}
              />
            </div>
          </div>

          <div className="w-100 flex flex-row justify-between margin-between">
            <Textarea
              name="notes"
              label="Admin note"
              value={customer.notes}
              valid={true}
              onChange={onChange}
            />
          </div>

          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-100">
              <TextEditor
                name="nurseNotes"
                valid={true}
                value={customer.nurseNotes}
                disabled
                label="Nurse's note"
                onChange={() => {}}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  const MobileView = (
    <section>
      <div className="pa5 pt4 br4 br--bottom-top bg-grouped-table flex flex-column">
        <div className="w-100 flex flex-column">
          <div>
            <Input
              name="lastName"
              label="Last Name"
              value={customer.lastName}
              valid={true}
              isCopiable={true}
              onChange={onChange}
            />
          </div>
          <div>
            <Input
              name="firstName"
              label="First Name"
              value={customer.firstName}
              valid={true}
              isCopiable={true}
              onChange={onChange}
            />
          </div>
          <div>
            <Input
              name="carteVitale"
              label="Carte Vitale number"
              value={formattedCarteVitale}
              valid={validation.carteVitale}
              validationText="Carte Vitale number must contain 15 digits"
              isCopiable={true}
              onChange={onChange}
            />
          </div>
          <div>
            <DateTimePicker
              label="Date of Birth"
              name="dob"
              valid={true}
              showYearDropdown={true}
              showTimeInput={false}
              value={customer.dateOfBirth}
              onChange={(value) => onDateChange({ value })}
            />
          </div>
          <div>
            <PhoneNumber
              name="phone"
              label="Phone number"
              value={customer.phone}
              isCopiable={true}
              valid={validation.phone}
              onChange={onPhoneChange}
            />
          </div>
          <div>
            <Input
              name="email"
              label="Email*"
              value={customer.email}
              valid={validation.email}
              validationText="Please enter a valid email"
              isCopiable={true}
              onChange={onChange}
            />
          </div>
          <div>
            <Address
              value={customer.address}
              name="address"
              label="Adresse line 1"
              type="text"
              valid={true}
              isCopiable={true}
              onChange={onChange}
              onSelect={(p) => {
                onAddressSelect(p.formatted_address);
              }}
            />
          </div>
          <div>
            <Input
              name="address2"
              label="Address line 2"
              value={customer.address2}
              valid={true}
              placeholder="Code, intercom, floor, apartment"
              isCopiable={true}
              onChange={onChange}
            />
          </div>

          <div>
            <Select
              className="doctor-select"
              valid={true}
              isMulti
              label="Non-sleep doctors"
              value={customerDoctors}
              options={doctorOptions}
              onChange={(selectedOption) => onDoctorSelect(selectedOption)}
            />
          </div>

          <div>
            <Radio
              name="patientRights"
              label="Patient's rights"
              value={customer.patientRights}
              valid={true}
              options={PATIENT_RIGHT_OPTIONS}
              onChange={(event) => onPatientRightsChange(event)}
            />
          </div>

          <div>
            <Radio
              name="gender"
              label="Gender"
              value={customer.gender}
              valid={true}
              options={GENDER_OPTIONS}
              onChange={(event) => onGenderChange(event)}
            />
          </div>

          <div>
            <Input
              name="height"
              label="Height"
              value={customer.height}
              valid={validation.height}
              validationText="Invalid input"
              trailingLabel={'cm'}
              onChange={onChange}
            />
            <Input
              name="weight"
              label="Weight"
              value={customer.weight}
              valid={validation.weight}
              validationText="Invalid input"
              trailingLabel={'kg'}
              onChange={onChange}
            />
            <Input
              name="bmi"
              label="BMI"
              value={customer.bmi}
              valid={validation.bmi}
              validationText="Invalid input"
              trailingLabel={'kg/m2'}
              onChange={onChange}
            />
          </div>

          <div className="w-100">
            <Textarea
              name="notes"
              label="Admin note"
              value={customer.notes}
              valid={true}
              onChange={onChange}
            />
          </div>

          <div className="w-100">
            <TextEditor
              name="nurseNotes"
              valid={true}
              disabled
              value={customer.nurseNotes}
              label="Nurse's note"
              onChange={() => {}}
            />
          </div>
        </div>
      </div>
    </section>
  );

  return isMobile ? MobileView : DesktopView;
};

export default GeneralInfo;
